// FILE: /src/Components/Sidebar.js (FULLY UPDATED)

import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; // <-- IMPORT useLocation
import { useSelector, useDispatch } from "react-redux";
import { Modal, Input, Tooltip } from "antd";

import { StoreSideBar } from "../store/Slices/SIdeSlice";
import { fetchGroups, setSelectedGroup } from "../store/Slices/GroupSlice";
import Logo from "../Assets/Icons/Group 619.svg";
import publishing from "../Assets/publishing.png";
import Assets from "../Assets/Cloud.png";

import Apps from "../Assets/apps.png";


import Reports from "../Assets/reports.png";

import Profile from "../Assets/profile.png";
import CreateBrandWorkflowModal from "./CreateGroup/CreateBrandWorkflowModal";
import ConnectProfileModal from "./ConnectProfileModal";
import UsageTracker from "./Dashboard/UsageTracker";
import UpgradeModal from "./BuySubscription/UpgradeModal";

const FEEDBACK_FORM_URL =
  process.env.REACT_APP_FEEDBACK_FORM_URL ||
  "https://forms.gle/LmVJ5jfs2hV7e6SX9";

export default function Sidebar() {
    const selector = useSelector((state) => state.SideBarName[0]);
    const { groups, selectedGroup } = useSelector((state) => state.groups);
    const { subscription } = useSelector((state) => state.subscription);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation(); // <-- ADD THIS HOOK

    const [dropdowns, setDropdowns] = useState({});
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
    const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
    const [isCreateBrandModalOpen, setIsCreateBrandModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [upgradeModal, setUpgradeModal] = useState({
    visible: false,
    message: "",
    featureName: "Reports",
    });

    const sidebarItems = useMemo(() => [
{ 
name: "Publishing", 
icon: publishing, 
path: "/Publishing", 
subItems: [
{ name: "Calender", path: "Publishing" }, 
{ name: "Queue", path: "QueuePage" }, 
{ name: "Links", path: "Links"}
] 
},
{
name: "Reports",
icon: Reports,
path: "/ProfileReports",
subItems: [
{ name: "Profile Reports", path: "ProfileReports" },
{ name: "Post Reports", path: "PostReports" }
]
},
{
name: "Assets",
icon: Assets,
path: "/Library",
subItems: [
{ name: "Brand Kit", path: "BrandKit" },
{ name: "Media", path: "Assets" },
{ name: "Brands", path: "GroupsProfile" }
]
},
{
name: "Apps",
icon: Apps,
path: "/Apps"
},
{ name: "Profile", icon: Profile, onClick: () => setIsConnectModalOpen(true) },


], []);
    
    // --- START: THIS IS THE FIX ---
    useEffect(() => {
        const currentPath = location.pathname;
        let activeName = null;
        let parentName = null;

        // Find the matching item or sub-item based on the current URL
        for (const item of sidebarItems) {
            if (item.subItems) {
                const subItemMatch = item.subItems.find(sub => `/Dashboard/${sub.path}` === currentPath);
                if (subItemMatch) {
                    activeName = subItemMatch.name;
                    parentName = item.name;
                    break;
                }
            } else if (item.path && currentPath.startsWith(`/Dashboard${item.path}`)) {
                 activeName = item.name;
                 break;
            }
        }
        
        // If the path is just /Dashboard, set a default active item if none match
        if(currentPath === '/Dashboard' || currentPath === '/Dashboard/'){
             activeName = "Publishing";
        }

        // Dispatch the action to update the sidebar's highlighted state
        if (activeName) {
            dispatch(StoreSideBar(activeName));
        }

        // Ensure the parent dropdown is open if a sub-item is active
        if (parentName && !dropdowns[parentName]) {
            setDropdowns(prev => ({ ...prev, [parentName]: true }));
        }

    }, [location.pathname, dispatch, sidebarItems, dropdowns]); // Re-run whenever the URL changes
    // --- END: THIS IS THE FIX ---

    useEffect(() => {
        dispatch(fetchGroups());
    }, [dispatch]);
    
    const toggleDropdown = (name) => setDropdowns((prev) => ({ ...prev, [name]: !prev[name] }));
    
    const filteredGroups = useMemo(() => {
        const activeGroups = groups.filter(g => g.status !== 'pending');
        if (!searchTerm) {
            return activeGroups;
        }
        return activeGroups.filter(group =>
            group.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [groups, searchTerm]);
    
    const reportsEnabled = subscription?.plan?.reports_enabled === true;

const openReportsUpgradeModal = () => {
setUpgradeModal({
visible: true,
featureName: "Reports",
message: "Reports are not included in your current plan. Please upgrade to access Profile and Post Reports.",
});
};

const handleSidebarItemClick = (item) => {
if (item.name === "Reports" && !reportsEnabled) {
openReportsUpgradeModal();
return;
}

if (item.path && !item.subItems) navigate(`/Dashboard${item.path}`);
if (item.subItems) toggleDropdown(item.name);
if (item.onClick) item.onClick();

dispatch(StoreSideBar(item.name));
};

const handleReportsSubItemClick = (event, subItem, parentName) => {
if (parentName === "Reports" && !reportsEnabled) {
event.preventDefault();
openReportsUpgradeModal();
return;
}

dispatch(StoreSideBar(subItem.name));
};

const logOut = () => {
localStorage.clear();
sessionStorage.clear();
window.location.href = "/";
};

return (
        <>
            <div className="w-64 bg-sidebar-bg text-sidebar-text h-screen flex flex-col relative">
                <img style={{ cursor: "pointer" }} onClick={() => navigate("/Dashboard")} src={Logo} alt="Logo" className="object-contain h-16 w-66 p-L-2 border-b border-sidebar-border"/>
                <ul className="mt-4 px-2">
                  <li>
                    <div className="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-sidebar-active-bg border-2 border-dashed border-sidebar-border" onClick={() => setIsGroupModalOpen(true)}>
                      <span className="flex-grow truncate">
                        {selectedGroup && selectedGroup !== "undefined" ? (
                          <div className="flex items-center justify-start gap-2">
                            <i className="fa fa-chevron-down text-xs"></i>
                            <span>{selectedGroup}</span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 text-sidebar-text">
                            <i className="fa fa-chevron-down text-xs"></i>
                            <span>Select a group</span>
                          </div>
                        )}
                      </span>
                    </div>
                  </li>
                </ul>
                <ul className="flex-grow space-y-1 mt-6 px-2">
                  {sidebarItems.map((item, index) => (
                    <li key={index}>
                      <div>
                        <div
                          className={`flex items-center px-4 py-2 rounded-lg cursor-pointer transition-colors ${
                            selector === item.name ? "bg-sidebar-active-bg text-sidebar-active-text" : "hover:bg-sidebar-hover-bg"
                          }`}
                          onClick={() => handleSidebarItemClick(item)}
                        >
                          <img src={item.icon} alt={`${item.name} Icon`} className="h-4 w-4 mr-4"/>
                          <span>{item.name}</span>
                          {item.subItems && (<i className={`fa fa-chevron-down ml-auto text-xs transform transition-transform ${dropdowns[item.name] ? "rotate-180" : ""}`}/>)}
                        </div>
                        {item.subItems && dropdowns[item.name] && (
                          <ul className="ml-8 mt-2 space-y-2">
                            {item.subItems.map((subItem, subIndex) => (
                              <li key={subIndex}>
                                <Link
to={subItem.path}
onClick={(event) => handleReportsSubItemClick(event, subItem, item.name)}
className={`block px-4 py-1.5 text-sm rounded-lg transition-colors ${
selector === subItem.name
? "bg-sidebar-active-bg text-sidebar-active-text font-semibold"
: "text-sidebar-text hover:bg-sidebar-hover-bg"
}`}
>
{subItem.name}
{item.name === "Reports" && !reportsEnabled ? (
<i className="fa-solid fa-lock ml-2 text-xs opacity-70"></i>
) : null}
</Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>

                <UsageTracker />

                <div className="p-2 border-t border-sidebar-border relative">
                  <button className="flex items-center w-full px-2 py-2 rounded-lg hover:bg-sidebar-hover-bg" onClick={() => setShowSubMenu((prev) => !prev)}>
                    <i className="fa fa-cog h-4 w-4 mr-4"></i>
                    <span>Settings</span>
                    <i className={`fa fa-chevron-${showSubMenu ? "up" : "down"} ml-auto text-xs`}></i>
                  </button>
                  {showSubMenu && (
<ul className="bg-sidebar-bg border border-sidebar-border rounded-lg shadow-lg absolute left-2 right-2 z-10 bottom-full mb-1">
<li className="border-b border-sidebar-border">
<Link to="https://oolook.in/privacy" className="block px-4 py-2 hover:bg-sidebar-hover-bg rounded-t-lg text-sm">Privacy Policy</Link>
</li>
<li className="border-b border-sidebar-border">
<Link to="AccountSetting" className="block px-4 py-2 hover:bg-sidebar-hover-bg text-sm">Account Billing</Link>
</li>
<li className="border-b border-sidebar-border">
<Link to="https://calendly.com/yogesh-oolook/30min" className="block px-4 py-2 hover:bg-sidebar-hover-bg text-sm">Support</Link>
</li>
<li>
<button onClick={logOut} className="w-full text-left px-4 py-2 hover:bg-sidebar-hover-bg rounded-b-lg text-sm">Log Out</button>
</li>
</ul>
)}
</div>

<Tooltip
  title="Report a bug, request a feature, or send feedback"
  placement="right"
>
  <button
    type="button"
    onClick={() =>
      window.open(FEEDBACK_FORM_URL, "_blank", "noopener,noreferrer")
    }
    className="absolute right-1 bottom-48 w-8 h-8 rounded-full bg-red-600 text-white shadow-xl border-2 border-red-300 hover:bg-red-700 hover:scale-105 transition-all flex items-center justify-center z-30"
    aria-label="Report feedback"
  >
    <i className="fa-solid fa-bug text-xl"></i>
  </button>
</Tooltip>
</div>

            <CreateBrandWorkflowModal isOpen={isCreateBrandModalOpen} onClose={() => setIsCreateBrandModalOpen(false)}/>
            
            <Modal
                title={<span className="font-semibold text-lg">Switch Brand</span>}
                open={isGroupModalOpen}
                onCancel={() => setIsGroupModalOpen(false)}
                footer={null}
                centered
            >
                <div className="py-4 space-y-4">
                    <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <i className="fa-solid fa-search text-gray-400"></i>
                        </span>
                        <Input
                            placeholder="Search brands..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 border rounded-lg"
                        />
                    </div>
                    
                    <ul className="space-y-2 max-h-60 overflow-y-auto pr-2">
                        {filteredGroups.length > 0 ? (
                            filteredGroups.map((group) => (
                                <li key={group.name}>
                                    <button
                                        onClick={() => {
                                            dispatch(setSelectedGroup(group.name));
                                            setIsGroupModalOpen(false);
                                        }}
                                        className={`w-full text-left p-3 rounded-lg transition-colors flex items-center justify-between ${
                                            selectedGroup === group.name
                                                ? 'bg-brand-primary text-white font-semibold'
                                                : 'bg-gray-50 hover:bg-purple-50 hover:text-brand-primary'
                                        }`}
                                    >
                                        <div className="flex items-center">
                                            <i className={`fa-regular fa-building mr-3 ${selectedGroup === group.name ? 'text-white' : 'text-gray-400'}`}></i>
                                            <span>{group.name}</span>
                                        </div>
                                        {selectedGroup === group.name && <i className="fa-solid fa-check-circle"></i>}
                                    </button>
                                </li>
                            ))
                        ) : (
                            <div className="text-center p-4 text-gray-500">
                                {searchTerm ? `No brands found for "${searchTerm}"` : "You haven't created any brands yet."}
                            </div>
                        )}
                    </ul>

                    <div className="border-t pt-4">
                        <button
                            onClick={() => {
                                setIsGroupModalOpen(false);
                                setIsCreateBrandModalOpen(true);
                            }}
                            className="w-full text-left p-3 rounded-lg transition-colors border-2 border-dashed border-gray-300 hover:border-brand-primary hover:bg-purple-50 flex items-center"
                        >
                            <i className="fa-solid fa-plus-circle mr-3 text-brand-primary"></i>
                            <span className="font-semibold text-gray-700">Create a New Brand</span>
                        </button>
                    </div>
                </div>
            </Modal>
            
            <ConnectProfileModal
isOpen={isConnectModalOpen}
onClose={() => setIsConnectModalOpen(false)}
/>
<UpgradeModal
isOpen={upgradeModal.visible}
onClose={() =>
setUpgradeModal({
visible: false,
message: "",
featureName: "Reports",
})
}
message={upgradeModal.message}
featureName={upgradeModal.featureName}
/>
</>
);
}